import { AxiosResponse } from 'axios';

import { FavouriteItemType } from '../../enums';
import { AddFavouriteItemResponse, RemoveFavouriteItemResponse } from '../../interfaces';
import { phpApi } from '../default';

export const addFavouriteItem: (type: FavouriteItemType, id: number) => Promise<AddFavouriteItemResponse>
= (type: FavouriteItemType, id: number): Promise<AddFavouriteItemResponse> => phpApi.post(`/api/user/favorite/${type}/${id}`).then(
  (response: AxiosResponse<AddFavouriteItemResponse>): AddFavouriteItemResponse => response.data);

export const removeFavouriteItem: (type: FavouriteItemType, id: number) => Promise<RemoveFavouriteItemResponse>
= (type: FavouriteItemType, id: number): Promise<RemoveFavouriteItemResponse> => phpApi.delete(`/api/user/favorite/${type}/${id}`).then(
  (response: AxiosResponse<RemoveFavouriteItemResponse>): RemoveFavouriteItemResponse => response.data);
